module.exports = "/_next/static/images/3f2d15e92d1b9c67755a32e80d3d2d9d-nubanker-tpm@2x.jpg";